import ApiService from "../../ApiService";

const RewardPlanListService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/rewardplanlist/loadscreenview", {}, successCallback, failureCallback);
    },
    deleteRewardPlan: (id, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/rewardplanlist/deleterewardplan", { id }, successCallback, failureCallback);
    }
};

export default RewardPlanListService;